module.exports = __webpack_public_path__ + "img/4.18de10a5.jpg";